import React from 'react';

const IconGeo = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" aria-hidden><path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z"/><path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/></svg>
);
const IconBuilding = () => (
  <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor" aria-hidden><path d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022zM6 8.694 1 10.36V15h5V8.694zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15z"/><path d="M2 11h1v1H2v-1zm2 0h1v1H4v-1zm-2 2h1v1H2v-1zm2 0h1v1H4v-1zm4-4h1v1H8V9zm2 0h1v1h-1V9zm-2 2h1v1H8v-1zm2 0h1v1h-1v-1zm2-2h1v1h-1V9zm0 2h1v1h-1v-1zM8 7h1v1H8V7zm2 0h1v1h-1V7zm2 0h1v1h-1V7zM8 5h1v1H8V5zm2 0h1v1h-1V5zm2 0h1v1h-1V5zm0-2h1v1h-1V3z"/></svg>
);
const IconLink = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" aria-hidden><path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 0 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/><path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 0 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 0 0-4.243-4.243L8.586 5.5z"/></svg>
);
const IconArrowUpRight = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden><path fillRule="evenodd" d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0v-6z"/></svg>
);

function domainDisplay(domain) {
  if (!domain) return '';
  const u = domain.replace(/^https?:\/\//, '').replace(/\/$/, '');
  return u.length > 25 ? u.substring(0, 25) + '…' : u;
}

function RegistryItemCard({ descriptor, onSelect }) {
  const companyData = descriptor.company_data || {};
  const companyName = companyData.company_name || descriptor.company_name || 'Unknown Company';
  const headquarters = companyData.headquarters || '';
  const description = companyData.company_description || '';
  const industries = companyData.industries || [];
  const domain = descriptor.domain || '';
  // Demo providers are sandboxes (workshop servers), not production services.
  // Label them so nobody mistakes one for a real provider's live data.
  const isDemo = Boolean(descriptor.demo);

  const handleClick = (e) => {
    if (e.target.closest('button')?.classList.contains('ds-view-button')) return;
    onSelect?.(descriptor);
  };

  return (
    <article
      className="ds-modern-card"
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect?.(descriptor);
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={`View details for ${companyName}`}
    >
      <div className="ds-card-header">
        <div className="ds-card-header__row">
          <div>
            <h3 className="ds-card-title">
              {companyName}
              {isDemo && (
                <span className="ds-demo-badge" title="Demo environment - not a production service">
                  Demo
                </span>
              )}
            </h3>
            {headquarters && (
              <div className="ds-card-location">
                <IconGeo />
                <span>{headquarters}</span>
              </div>
            )}
          </div>
          <div className="ds-card-icon">
            <IconBuilding />
          </div>
        </div>
      </div>
      <div className="ds-card-body">
        <p className="ds-card-description">{description || '—'}</p>
        {industries.length > 0 && (
          <div className="ds-industry-badges">
            {industries.slice(0, 2).map((ind, idx) => (
              <span key={idx} className="ds-industry-badge">{ind}</span>
            ))}
          </div>
        )}
        <div className="ds-info-grid">
          {domain && (
            <div className="ds-info-item">
              <div className="ds-info-icon">
                <IconLink />
              </div>
              <div className="ds-info-content">
                <span className="ds-info-label">Domain</span>
                <span className="ds-info-value">{domainDisplay(domain)}</span>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="ds-card-footer">
        <button
          type="button"
          className="ds-view-button"
          onClick={(e) => {
            e.stopPropagation();
            onSelect?.(descriptor);
          }}
        >
          <span>View Details</span>
          <IconArrowUpRight />
        </button>
      </div>
    </article>
  );
}

export default RegistryItemCard;
